import 'angular';
import { splitSlugAndId } from '../../utilities/utilities';
import '../../../../lib/assets/javascripts/devex/util';

angular
  .module('services.SlugAndIdService', [])
  .service('SlugAndIdService', [
    function() {
      /**
       * Extracts and returns the ID contained in a slug_and_id variable
       *
       * @param {string} slug_and_id : slug_and_id to be decomposed
       * @returns {Integer} The ID contained in the slug_and_id
       */
      var extractId = function(slug_and_id) {
        var slug_and_id_params = splitSlugAndId(slug_and_id);
        return slug_and_id_params.id;
      };

      /**
       * @param {string} text
       * @param {string | Integer} id
       *
       * @returns {string}
       */
      var createSlugAndId = function(text, id) {
        return devex.util.createSlugAndId(text, id);
      };

      return {
        'createSlugAndId': createSlugAndId,
        'splitSlugAndId': splitSlugAndId,
        'extractId': extractId
      };
    }
  ]);
